module.exports = __webpack_public_path__ + "static/media/portfolio-07 copy.6673fbd6.jpg";